import { UI, HStack, Stack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { LateralBar } from '../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import {
  DetailsSkeleton,
  DoubleTextSkeleton,
  TextSkeleton,
} from '../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';

export const SubscriptionCardLoadingDesktop: React.FC = () => {
  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Box p="inset.xs" w="full">
        <LateralBar
          backgroundColor="product.rendavariavel"
          borderTopLeftRadius="sm"
          borderBottomLeftRadius="sm"
        />
        <HStack justifyContent="space-between" alignItems="center" space="inline.xxxs">
          <HStack space="inline.xxxs" alignItems="center" flex={1}>
            <DetailsSkeleton />
            <DoubleTextSkeleton />
          </HStack>

          <Stack w="8%">
            <DoubleTextSkeleton />
          </Stack>
          <Stack w="8%">
            <DoubleTextSkeleton />
          </Stack>
          <Stack w="8%">
            <DoubleTextSkeleton />
          </Stack>
          <Stack w="8%">
            <DoubleTextSkeleton />
          </Stack>
          <Stack w="8%">
            <DoubleTextSkeleton />
          </Stack>
          <Stack w="8%">
            <DoubleTextSkeleton />
          </Stack>
          <TextSkeleton w="5%" />
        </HStack>
      </Box>
    </UI.Shadow>
  );
};
